export interface IAddTicketReplyRequest  {
    TicketID: number;
    Message: string;
    UserID: number;
    ContactID: number;
    useMarkDown: boolean;
    AdminUsername: string;
    Name: string;
    Email: string;
    Status: string;
    NoEmail: boolean;

}

export class AddTicketReplyRequest  implements IAddTicketReplyRequest {
    TicketID: number;
    Message: string;
    UserID: number;
    ContactID: number;
    useMarkDown: boolean;
    AdminUsername: string;
    Name: string;
    Email: string;
    Status: string;
    NoEmail: boolean;

}
